export const NO_PROGRAM_ID = '11111111-1111-1111-1111-111111111111';

export const NO_PROGRAM_LABEL = 'other';
